import Head from "next/head";
import { useEffect } from "react";
import Layout from "../components/Layout";
import Loader from "../components/Loader";
import useAllCrditSkusStore from "../zustandStores/allCreditSkus";
import LogService from "../services/LogService";
import CREDIT_EVENTS from "../utils/CreditEvents";
import ScreenError from "../components/ScreenError";
import PlanSelectionWrapper from "../components/PlanSelectionWrapper";

export default function PlanSelectionPage(props) {
  const { fetchData, fetchedState } = useAllCrditSkusStore(state => ({
    fetchData: state.fetchData,
    fetchedState: state.fetchedState
  }));

  useEffect(() => {
    fetchData();
    LogService.log(CREDIT_EVENTS.PLAN_SELECTION_PAGE_LANDED, {
      trackSource: true
    });
  }, []);

  return (
    <>
      <Head>
        <title>Job Hai - Premium plan selection</title>
      </Head>
      <Layout isFooter={false} isLogin={true} isHeaderFixed={true}>
        {fetchedState === "LOADING" ? <Loader /> : null}
        {fetchedState === "ERROR" ? <ScreenError /> : null}
        {fetchedState === "SUCCESS" ? <PlanSelectionWrapper /> : null}
      </Layout>
    </>
  );
}
